import { render, staticRenderFns } from "./year.vue?vue&type=template&id=6060637e&scoped=true&lang=pug&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=6060637e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060637e",
  null
  
)

component.options.__file = "year.vue"
export default component.exports